import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-753ff8fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stack" }

import useMultiStateButton, {MultiStateButtonProps} from '@/services/composables/MultiStateButton';
    
export default /*#__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false
    },
  __name: 'MultiStateButton',
  props: {
    modelValue: {},
    states: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    
    const props = __props;
    const emits = __emit;
    const {
        display,
        toggleState
    } = useMultiStateButton(props, emits);
    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _mergeProps(_ctx.$attrs, {
      type: "button",
      class: "stack-item",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleState) && _unref(toggleState)(...args)))
    }), _toDisplayString(_unref(display)), 17),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (x) => {
      return (_openBlock(), _createElementBlock("button", _mergeProps(_ctx.$attrs, {
        class: "stack-item hidden",
        disabled: ""
      }), _toDisplayString(x), 17))
    }), 256))
  ]))
}
}

})